import { SketchNoteLogoIcon } from '@sketchnote/icons';
import { CoverImage } from 'src/components/CoverImage';

export const FormHeader = ({
  showCover,
  coverImage,
}: {
  showCover?: boolean;
  coverImage?: string;
}) => {
  return showCover ? (
    <div className="relative">
      {coverImage && <CoverImage coverImage={coverImage} disabled={true} />}

      <div
        style={{ paddingLeft: '1%' }}
        className="absolute mx-auto rounded-xl left-0 right-0 -bottom-45 mb-32 mobile:w-93p tablet:w-86p laptop:w-84p desktop:w-73p  bg-white"
      >
        <div className="py-32 flex items-center">
          <SketchNoteLogoIcon className="text-primary-500 text-4xl" />
          <span className="text-primary-800 font-extraBold ml-4 text-xl">sketchnote</span>
        </div>
      </div>
    </div>
  ) : (
    <div className="mx-auto mobile:w-90p tablet:w-84p laptop:w-80p desktop:w-69p  my-32">
      <div className="flex items-center bg-white ">
        <SketchNoteLogoIcon className="text-primary-500 text-4xl -ml-3" />
        <span className="text-primary-800 font-extraBold ml-4 text-xl">sketchnote</span>
      </div>
    </div>
  );
};
